import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import Pagination from "react-js-pagination";
import "./WeddingPagination.css";

const WeddingPagination = ({
  currentPage,
  setCurrentPage,
  totalItemsCount,
  itemsCountPerPage,
  paginationChange,
  setPaginationChange,
  localVariable,
}) => {
  const [activePage, setActivePage] = useState(currentPage);
  const pageref = useRef();
  let pagesToDisplay;

  console.log("fixed values", totalItemsCount, itemsCountPerPage);

  if (window.innerWidth > 750) {
    pagesToDisplay = 8;
  } else if (window.innerWidth > 470 && window.innerWidth <= 750) {
    pagesToDisplay = 4;
  } else {
    pagesToDisplay = 2;
  }

  useEffect(() => {
    setCurrentPage(activePage);
  }, [activePage]);

  const handlePageChange = (pageNumber) => {
    console.log(`active page is ${pageNumber}`);
    setActivePage(pageNumber);
    setPaginationChange({ ...paginationChange, page: pageNumber });
    localStorage.setItem(
      localVariable,
      JSON.stringify({
        ...paginationChange,
        page: pageNumber,
        limit: itemsCountPerPage,
      })
    );
  };

  useEffect(() => {
    setActivePage(Number(currentPage));
  }, [currentPage]);

  console.log("page ref", pageref, activePage);

  const handlePrevButtonClick = () => {
    if (paginationChange?.page > 1) {
      setActivePage(paginationChange?.page - 1);
      setPaginationChange({
        ...paginationChange,
        page: paginationChange?.page - 1,
      });
      localStorage.setItem(
        localVariable,
        JSON.stringify({
          ...paginationChange,
          page: paginationChange?.page - 1,
          limit: itemsCountPerPage,
        })
      );
    }
  };

  const handleNextButtonClick = () => {
    // Assuming a total of 10 pages, you can adjust this based on your actual totalItemsCount
    const totalPages = Math.ceil(totalItemsCount / itemsCountPerPage);

    if (paginationChange?.page < totalPages) {
      setActivePage(paginationChange?.page + 1);
      setPaginationChange({
        ...paginationChange,
        page: paginationChange?.page + 1,
      });
      localStorage.setItem(
        localVariable,
        JSON.stringify({
          ...paginationChange,
          page: paginationChange?.page + 1,
          limit: itemsCountPerPage,
        })
      );
    }
  };

  return (
    <div className="custom-pagination-wedding">
      <p
        onClick={handlePrevButtonClick}
        className={
          paginationChange?.page != 1 ? "prev-button" : "prev-button-disabled"
        }
      >
        Prev
      </p>
      <Pagination
        ref={pageref}
        activePage={Number(paginationChange?.page) || activePage}
        itemsCountPerPage={itemsCountPerPage}
        totalItemsCount={totalItemsCount}
        pageRangeDisplayed={pagesToDisplay}
        // pageRangeDisplayed={window.innerWidth>500 ? 5: (window.innerWidth<300 ? 2 : 3)}
        onChange={handlePageChange}
      />
      <p
        onClick={handleNextButtonClick}
        className={
          paginationChange?.page !=
          Math.ceil(totalItemsCount / itemsCountPerPage)
            ? "next-button"
            : "next-button-disabled"
        }
      >
        Next
      </p>
    </div>
  );
};

export default WeddingPagination;
